module.exports = __webpack_public_path__ + "img/500.fcca204.svg";